import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, mergeProps as _mergeProps, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-650px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h2", null, "Add New Venue", -1)
const _hoisted_6 = { class: "btn btn-sm btn-icon btn-active-color-primary" }
const _hoisted_7 = { class: "svg-icon svg-icon-1" }
const _hoisted_8 = { class: "d-flex flex-column flex-md-row gap-4 gap-md-5" }
const _hoisted_9 = { class: "d-flex flex-column w-100" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-5 fw-bold mb-2" }, "Name", -1)
const _hoisted_11 = { class: "fv-plugins-message-container" }
const _hoisted_12 = { class: "fv-help-block" }
const _hoisted_13 = { class: "d-flex flex-column w-100" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", {
  for: "clientsDropdown",
  class: "form-label"
}, "Client", -1)
const _hoisted_15 = { class: "d-flex flex-column flex-md-row gap-4 gap-md-5" }
const _hoisted_16 = { class: "d-flex flex-column w-100" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", { class: "fs-5 fw-bold mb-2" }, "Entrance", -1)
const _hoisted_18 = { class: "d-flex flex-column w-100" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-5 fw-bold mb-2" }, "Address", -1)
const _hoisted_20 = { class: "fv-plugins-message-container" }
const _hoisted_21 = { class: "fv-help-block" }
const _hoisted_22 = { class: "d-flex flex-column flex-md-row gap-4 gap-md-5" }
const _hoisted_23 = { class: "d-flex flex-column w-100" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-5 fw-bold mb-2" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "Country")
], -1)
const _hoisted_25 = { class: "fv-plugins-message-container" }
const _hoisted_26 = { class: "fv-help-block" }
const _hoisted_27 = { class: "d-flex flex-column w-100" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-5 fw-bold mb-2" }, "City", -1)
const _hoisted_29 = { class: "fv-plugins-message-container" }
const _hoisted_30 = { class: "fv-help-block" }
const _hoisted_31 = { class: "d-flex flex-column flex-md-row gap-4 gap-md-5" }
const _hoisted_32 = { class: "d-flex flex-column" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("label", { class: "fs-5 fw-bold mb-2" }, "ZIP code", -1)
const _hoisted_34 = { class: "fv-plugins-message-container" }
const _hoisted_35 = { class: "fv-help-block" }
const _hoisted_36 = { class: "d-flex flex-column" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("label", { class: "fs-5 fw-bold mb-2" }, "Province", -1)
const _hoisted_38 = { class: "fv-plugins-message-container" }
const _hoisted_39 = { class: "fv-help-block" }
const _hoisted_40 = { class: "w-100 d-flex flex-column" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("label", {
  for: "venue_notes",
  class: "form-label"
}, "Notes", -1)
const _hoisted_42 = { class: "gap-5 d-flex justify-content-end w-100 py-5" }
const _hoisted_43 = ["disabled"]
const _hoisted_44 = {
  key: 0,
  class: "spinner-border spinner-border-sm align-middle me-1"
}
const _hoisted_45 = /*#__PURE__*/_createTextVNode(" Save ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_CountriesDropdown = _resolveComponent("CountriesDropdown")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", {
    class: "modal fade",
    id: _ctx.modalId,
    "aria-hidden": "true"
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("span", _hoisted_7, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotone/Navigation/Close.svg" })
            ])
          ])
        ]),
        (_openBlock(), _createBlock(_component_Form, {
          key: _ctx.formKey,
          onSubmit: _ctx.handleSubmit,
          "validation-schema": _ctx.validation,
          class: "d-flex flex-column gap-5 w-100 p-5 px-7"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                _createVNode(_component_Field, {
                  type: "text",
                  class: "form-control form-control-solid",
                  placeholder: "Enter name",
                  name: "name"
                }),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _createVNode(_component_ErrorMessage, { name: "name" })
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _hoisted_14,
                _createVNode(_component_el_select, {
                  modelValue: _ctx.client,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.client) = $event)),
                  size: "large",
                  placeholder: "Select a client",
                  class: "w-100"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.companies, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.value,
                        label: item.label,
                        value: item.value
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _hoisted_17,
                _createVNode(_component_Field, {
                  type: "text",
                  class: "form-control form-control-solid",
                  placeholder: "Enter entrance",
                  name: "entrance"
                })
              ]),
              _createElementVNode("div", _hoisted_18, [
                _hoisted_19,
                _createVNode(_component_Field, {
                  type: "text",
                  class: "form-control form-control-solid",
                  placeholder: "Enter address",
                  name: "address"
                }),
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    _createVNode(_component_ErrorMessage, { name: "address" })
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _hoisted_24,
                _createVNode(_component_CountriesDropdown, {
                  ref: "countriesDropdown",
                  name: 'country'
                }, null, 512),
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("div", _hoisted_26, [
                    _createVNode(_component_ErrorMessage, { name: "country" })
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_27, [
                _hoisted_28,
                _createVNode(_component_Field, {
                  class: "form-control form-control-solid",
                  placeholder: "Enter city",
                  name: "city"
                }),
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("div", _hoisted_30, [
                    _createVNode(_component_ErrorMessage, { name: "city" })
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("div", _hoisted_32, [
                _hoisted_33,
                _createVNode(_component_Field, {
                  class: "form-control form-control-solid",
                  placeholder: "Enter ZIP",
                  name: "zip"
                }),
                _createElementVNode("div", _hoisted_34, [
                  _createElementVNode("div", _hoisted_35, [
                    _createVNode(_component_ErrorMessage, { name: "zip" })
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_36, [
                _hoisted_37,
                _createVNode(_component_Field, {
                  class: "form-control form-control-solid",
                  placeholder: "Province",
                  name: "province"
                }),
                _createElementVNode("div", _hoisted_38, [
                  _createElementVNode("div", _hoisted_39, [
                    _createVNode(_component_ErrorMessage, { name: "province" })
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_40, [
              _hoisted_41,
              _createVNode(_component_Field, { name: "notes" }, {
                default: _withCtx(({ field }) => [
                  _createElementVNode("textarea", _mergeProps(field, {
                    class: "form-control",
                    id: "venue_notes",
                    rows: "3"
                  }), null, 16)
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_42, [
              _createElementVNode("button", {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleModal(false))),
                type: "button",
                class: "btn btn-secondary"
              }, " Cancel "),
              _createElementVNode("button", {
                disabled: _ctx.loading,
                class: "btn btn-primary"
              }, [
                (_ctx.loading)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_44))
                  : _createCommentVNode("", true),
                _hoisted_45
              ], 8, _hoisted_43)
            ])
          ]),
          _: 1
        }, 8, ["onSubmit", "validation-schema"]))
      ])
    ])
  ], 8, _hoisted_1))
}